import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import styles from "./ClickToCloseWrapper.css";

export default class ClickToCloseWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.clickToClose = this._clickToClose.bind(this);
  }

  _clickToClose(e) {
    const isInside = this.ref && !this.ref.contains(e.target);
    if (this.props.closeOnFirstClick || isInside) {
      this.props.onClose();
    }
  }

  componentDidMount() {
    if (this.props.onClose && this.props.isVisible) {
      document.addEventListener("click", this.clickToClose);
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.clickToClose);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.onClose) {
      if (!this.props.isVisible && nextProps.isVisible) {
        document.addEventListener("click", this.clickToClose);
      } else if (this.props.isVisible && !nextProps.isVisible) {
        document.removeEventListener("click", this.clickToClose);
      }
    }
  }

  render() {
    return (
      <div
        className={classNames(styles.root, this.props.className, {
          [this.props.visibleClassName]: this.props.isVisible,
        })}
        aria-live="assertive"
        ref={node => {
          this.ref = node;
        }}
      >
        {this.props.children}
      </div>
    );
  }
}

ClickToCloseWrapper.defaultProps = {
  isVisible: false,
};

ClickToCloseWrapper.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
  className: PropTypes.string,
  visibleClassName: PropTypes.string,
  closeOnFirstClick: PropTypes.bool,
};
